// extracted by mini-css-extract-plugin
module.exports = {"expandableView":"Collapse_expandableView__1Aif9","collapseState":"Collapse_collapseState__1GYgV","showMore":"Collapse_showMore__305Ax"};